// @ts-nocheck
import * as GraphQLSchema from '../graphql-types';

import * as Operations from './client-search-workers-query.graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ClientSearchWorkersQueryVariables = GraphQLSchema.Exact<{
  after?: GraphQLSchema.InputMaybe<GraphQLSchema.Scalars['String']['input']>;
  filters?: GraphQLSchema.InputMaybe<GraphQLSchema.WorkerSearchFilterAttribute>;
  first?: GraphQLSchema.InputMaybe<GraphQLSchema.Scalars['Int']['input']>;
}>;


export type ClientSearchWorkersQuery = { __typename?: 'Query', clientSearchWorkers?: { __typename?: 'WorkerProfileSearchNodeConnection', totalCount: number, pageNumber: number, nodes?: Array<{ __typename?: 'WorkerProfileSearchNode', id: string, about?: string | null, normalizedType: string, combinedFeedback?: number | null, deliveredHourGroup?: string | null, distanceAway?: number | null, loyaltyName?: string | null, ratings?: Array<{ __typename?: 'Rating', id: string }> | null, clientFields: { __typename?: 'ClientFields', shortlisted?: boolean | null }, user: { __typename?: 'User', id: string, permalink: string, truncatedName: string, firstName: string, avatar?: { __typename?: 'Avatar', big?: string | null } | null } } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };


  @Injectable({
    providedIn: 'root'
  })
  export class ClientSearchWorkersQueryService extends Apollo.Query<ClientSearchWorkersQuery, ClientSearchWorkersQueryVariables> {
    document = Operations.ClientSearchWorkersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }